import { useEffect } from "react"
import { graphql, useStaticQuery } from "gatsby"
import { setProducts } from "@/redux/features/productsSlice"
import { useAppSelector, useAppDispatch } from "@/redux/hooks"
import * as styles from "@/styles/modules/Layout.module.scss"
import AmbassadorHeader from "./AmbassadorHeader"
import ErrorModal from "./ErrorModal"
import Footer from "./Footer"
import Header from "./Header"

interface LayoutProps {
  header?: boolean
  footer?: boolean
  forceHeaderBkg?: boolean
  forceTheme?: "light" | "dark"
  isAmbassador?: boolean
  wrapperClass?: string
  showSignupBanner?: boolean
}

interface SanityProduct {
  product: {
    type: string
    title: string
    subscribeId: string
    productId: string
  }
}

const Layout = ({
  children,
  footer = true,
  forceHeaderBkg = false,
  forceTheme,
  header = true,
  isAmbassador,
  wrapperClass,
  showSignupBanner = true,
}: React.PropsWithChildren<LayoutProps>) => {
  const activeUser = useAppSelector(state => state.activeUser)
  const dispatch = useAppDispatch()

  const data = useStaticQuery(graphql`
    query LayoutQuery {
      allSanityProducts {
        nodes {
          product {
            type
            title
            subscribeId
            productId
          }
        }
      }
    }
  `)

  const products = data.allSanityProducts.nodes.map(
    (node: SanityProduct) => node.product,
  )

  // Dispatch products to Redux store
  useEffect(() => {
    dispatch(setProducts(products))
  }, [dispatch, products])

  return (
    <>
      {header && !isAmbassador && (
        <Header
          forceBackground={forceHeaderBkg}
          forceTheme={forceTheme}
          activeUser={activeUser}
          showSignupBanner={showSignupBanner}
        />
      )}
      {header && isAmbassador && (
        <AmbassadorHeader
          forceBackground={forceHeaderBkg}
          forceTheme={forceTheme}
          activeUser={activeUser}
        />
      )}

      <div className={`${styles.layoutWrapper} ${wrapperClass || ""}`}>
        {children}
      </div>
      {footer && <Footer activeUser={activeUser} />}
      <ErrorModal />
    </>
  )
}

export default Layout
